import React from "react";
import styles from "./CampaignSubmissionModal.module.css";

interface CampaignSubmissionModalProps {
  isOpen: boolean;
  onConfirmation: () => void;
  title: string;
  body?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  ctaText: string;
}

export const CampaignSubmissionModal: React.FC<CampaignSubmissionModalProps> = ({
  isOpen,
  onConfirmation,
  title,
  body,
  icon: Icon,
  ctaText,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        {Icon && (
          <div className={styles.iconWrapper}>
            <Icon className={styles.iconSvg} />
          </div>
        )}
        <h2 className={styles.title}>{title}</h2>
        {body && <div className={styles.body}>{body}</div>}
        <div className={styles.helpText}>
          Need help? Email{" "}
          <a href="mailto:support@oppizi.com" className={styles.helpLink}>
            support@oppizi.com
          </a>
        </div>
        <button className={styles.ctaButton} onClick={onConfirmation} type="button">
          {ctaText}
        </button>
      </div>
    </div>
  );
};

export default CampaignSubmissionModal;
